// extracted by mini-css-extract-plugin
module.exports = {"body":"ResubSuccessCard_body__1fYAk","status":"ResubSuccessCard_status__1TvVP","msg":"ResubSuccessCard_msg__2lyx2"};